import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / IFillableNode`}</p>
    <h1 {...{
      "id": "interface-ifillablenode"
    }}>{`Interface: IFillableNode`}</h1>
    <p>{`Interface for `}<a parentName="p" {...{
        "href": "../classes/FillableNode.md"
      }}>{`FillableNode`}</a>{` `}<em parentName="p">{`and`}</em>{` any other nodes with a similar `}<inlineCode parentName="p">{`fills`}</inlineCode>{` API that do not directly inherit from the
FillableNode class.`}</p>
    <h2 {...{
      "id": "implemented-by"
    }}>{`Implemented by`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../classes/FillableNode.md"
        }}><inlineCode parentName="a">{`FillableNode`}</inlineCode></a></li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "IFillableNode.md#fills"
        }}>{`fills`}</a></li>
    </ul>
    <h2 {...{
      "id": "properties-1"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "a-idfills-namefillsa-fills"
    }}><a id="fills" name="fills"></a>{` fills`}</h3>
    <p>{`• `}<strong parentName="p">{`fills`}</strong>{`: `}<a parentName="p" {...{
        "href": "../classes/ItemList.md"
      }}><inlineCode parentName="a">{`ItemList`}</inlineCode></a>{`<`}<a parentName="p" {...{
        "href": "Fill.md"
      }}><inlineCode parentName="a">{`Fill`}</inlineCode></a>{`>`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      